// @flow
import React from 'react'

import { Flex } from 'components/common'
import classnames from 'classnames'
import { useLoaderStyles } from './styles'

type LoaderProps = {
  type?: 'bars' | 'dots',
  size?: 'small' | 'medium',
  isRelative?: boolean
}

const Loader = ({ type = 'bars', size = 'medium', isRelative, ...props }: LoaderProps) => {
  const classes = useLoaderStyles()

  const DotsLoader = (
    <Flex
      justifyCenter
      style={{
        margin: '0.5rem 0',
        width: '50px'
      }}
    >
      <div className={classnames(classes.dotsLoader, { small: size === 'small' })}></div>
    </Flex>
  )

  const BarsLoader = (
    <>
      <div className={classes.barLoaderItem} />
      <div className={classes.barLoaderItem} />
      <div className={classes.barLoaderItem} />
      <div className={classes.barLoaderItem} />
    </>
  )

  return (
    <Flex
      className={classnames({
        [classes.absolute]: !isRelative
      })}
      justifyCenter
      {...props}
    >
      {type === 'dots' && DotsLoader}
      {type === 'bars' && BarsLoader}
    </Flex>
  )
}

export default Loader
